const url = 'http://girosnacionalesdev';
const urlFront = "http://localhost:4200";
export const environment = {
  production: false,
  envName: 'local',
  apiUrl: url,
  inactiveTime: 1800000,
  alertInactiveTime: 60,
  adalConfig: {
    /*tenant: 'jarajulianrestrepohotmail.onmicrosoft.com',
    clientId: '2a08d337-651b-4b31-a45c-1afedfa93935',*/
    tenant: '65a4c125-d91d-4545-9edd-73e3588f60a5',
    clientId: 'c9124225-6f5a-4a03-867c-4babbce8d0e9',
    redirectUri: urlFront + '/'
  }
};